module.exports = {
    "Empty": `\u{BE44}\u{C5B4} \u{C788}\u{C74C}`
};


//# sourceMappingURL=ko-KR.main.js.map
